<template>
  <div
    class="custom-head"
    :class="{
      active: navBarFixed,
      boxShadow: boxShadow,
      white: fontColor === 'white',
      black: fontColor === 'black',
    }"
  >
    <NavBar
      ref="CustomHead"
      left-arrow
      @click-left="onClickLeft"
      :class="{ 'no-border': noBorder }"
      :style="{
        backgroundColor: navBarFixed
          ? navBarFixedBackgroundColor
          : backgroundColor,
      }"
    >
      <template #title>
        <div class="title-wrapper">
          <div class="title">{{ title }}</div>
        </div>
      </template>
      <template #right>
        <div class="right-wrapper">
          <div class="item" v-if="showFocusBtn" @click="$emit('focusClick')">
            <img
              v-if="focusFlag"
              :src="require('@/assets/activityplace/like.svg')"
            />
            <img v-else :src="require('@/assets/activityplace/like空心.svg')" />
            <div class="text">关注</div>
          </div>
          <div class="item" @click="$emit('sharePoster')">
            <img
              :src="
                require('@/assets/activityplace/forward_' + fontColor + '.svg')
              "
            />
            <div class="text">转发</div>
          </div>
          <div class="item" @click="$router.push({ name: 'HomeMessage' })">
            <div v-if="messageTotal" class="badge">
              {{ messageTotal }}
            </div>
            <img
              :src="
                require('@/assets/activityplace/message_' + fontColor + '.svg')
              "
            />
            <div class="text">消息</div>
          </div>
        </div>
      </template>
    </NavBar>
  </div>
</template>

<script>
import { NavBar } from 'vant'
import { isWechatMP } from '@/utils/qiyukf'
export default {
  components: { NavBar },
  props: {
    // 标题
    title: {
      type: String,
      default: null,
    },
    // 固定时背景色
    navBarFixedBackgroundColor: {
      type: String,
      default: '#e82035',
    },
    // 是否监听滚动
    navBarToggle: {
      type: Boolean,
      default: false,
    },
    // 是否显示 border-bottom
    noBorder: {
      type: Boolean,
      default: true,
    },
    // 是否显示 box-shadow
    boxShadow: {
      type: Boolean,
      default: false,
    },
    // 返回路径 默认上一页
    backRoute: {
      type: String,
      default: null,
    },
    // 文字颜色
    fontColor: {
      type: String,
      default: 'white',
    },
    // 背景颜色
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
    // 是否显示关注按钮
    showFocusBtn: {
      type: Boolean,
      default: false,
    },
    // 是否关注
    focusFlag: {
      type: Boolean,
      default: false,
    },
    // 监听滚动的DOM
    scrollDOM: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      qiyuTotal: 0,
      navBarFixed: false,
    }
  },
  created() {},
  computed: {
    messageTotal() {
      return this.qiyuTotal + this.$store.state.app.messageNum
    },
  },
  mounted() {
    if (this.navBarToggle) {
      const dom = this.scrollDOM
        ? document.querySelector(this.scrollDOM)
        : window
      dom.addEventListener('scroll', this.watchScroll)
    }
  },
  beforeDestroy() {
    const dom = this.scrollDOM ? document.querySelector(this.scrollDOM) : window
    dom.removeEventListener('scroll', this.watchScroll)
  },
  updated() {
    // 客服消息监听
    if (!isWechatMP()) {
      ysf('onunread', function(result) {
        this.qiyuTotal = result.total
      })
    }
  },
  methods: {
    watchScroll() {
      const CustomHeadHeight = this.$refs.CustomHead.$el.offsetHeight
      const dom = this.scrollDOM
        ? document.querySelector(this.scrollDOM)
        : window

      var scrollTop = this.scrollDOM
        ? document.querySelector(this.scrollDOM).scrollTop
        : window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop

      if (scrollTop > CustomHeadHeight) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    onClickLeft() {
      if (this.backRoute) {
        this.$router.push({ name: this.backRoute })
      } else {
        if (this.$route.query.customerId || this.$route.params.customerId) {
          this.$router.push({ name: 'Home' })
        } else {
          this.$router.back()
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.custom-head {
  z-index: 50;
  &.boxShadow {
    /deep/ .van-nav-bar {
      box-shadow: 0 0 30px rgba(0, 0, 0, 0.14);
    }
  }
  & /deep/ .van-nav-bar {
    transition: 0.3s;
    background-color: transparent;
  }
  &.active /deep/ .van-nav-bar {
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.14);
  }
  .van-nav-bar {
    &.no-border::after {
      display: none;
    }
    /deep/ .van-nav-bar__content {
      height: 100px;
    }
    /deep/ .van-nav-bar__title {
      font-size: 28px;
      line-height: 28px;
      font-weight: 600;
    }
    /deep/ .van-nav-bar__arrow {
      font-size: 40px;
    }
  }
  .right-wrapper {
    display: flex;
    .item {
      position: relative;
      display: inline-block;
      text-align: center;
      & + .item {
        margin-left: 22px;
      }
      img {
        display: block;
        margin: 0 auto;
        width: 36px;
        height: 36px;
      }
      .text {
        font-size: 16px;
        font-weight: 300;
        color: #ffffff;
        line-height: 28px;
      }
    }
    .badge {
      position: absolute;
      top: -4px;
      right: -10px;
      width: 24px;
      height: 24px;
      text-align: center;
      line-height: 18px;
      font-size: 18px;
      padding-top: 4px;
      border-radius: 100%;
    }
  }

  &.white .van-nav-bar {
    /deep/ .van-icon,
    /deep/ .van-nav-bar__title,
    .right-wrapper .text {
      color: #fff;
    }
    .right-wrapper .badge {
      background: #fff;
      color: #c82d26;
    }
  }
  &.black .van-nav-bar {
    /deep/ .van-icon,
    /deep/ .van-nav-bar__title,
    .right-wrapper .text {
      color: #333;
    }
    .right-wrapper .badge {
      background: #c82d26;
      color: #fff;
    }
  }
}
</style>
